import { create } from 'zustand'

/** A single email recipient to pre-fill the composer's "to" section with. */
export interface EmailComposerTarget {
  /** Email address to write to — used as the recipient `contact`. */
  email: string
  /** Display name shown in the recipient list. */
  name?: string
  /** Shipment this message is about, for history linkage. */
  shipmentId?: string
  /** Customer this recipient maps to. */
  customerId?: string
}

interface EmailComposerState {
  open: boolean
  target: EmailComposerTarget | null
  openComposer: (target: EmailComposerTarget) => void
  close: () => void
}

// Lives in `shared` (not the mass-email feature) so lower layers — e.g. the
// shared email-address cell rendered in tables and cards — can open the email
// composer with a recipient pre-filled, without importing upward across FSD
// layers. The mass-email feature mounts a single dialog driven by this store.
export const useEmailComposerStore = create<EmailComposerState>()((set) => ({
  open: false,
  target: null,
  openComposer: (target) => set({ open: true, target }),
  close: () => set({ open: false }),
}))

/** Open the email composer with a single recipient pre-filled. */
export function openEmailComposer(target: EmailComposerTarget): void {
  useEmailComposerStore.getState().openComposer(target)
}
